angular.module("screensApp").factory("WinnersService", function ($http, $rootScope) {
  return {
    getWinners: function () {
      switch ($rootScope.ENV) {
        case "localhost":
          return $http.get("data/winners.json");
        default:
          return $http.get(window.location.origin + "/winners/winners-" + $rootScope.config.Country + ".json");
      }
    },
  };
});
